module.exports = __webpack_public_path__ + "static/media/logo.85bcca2c.png";